import React from 'react';
import styled, { css } from 'styled-components';

import { EColor, EIcon, ESize, EZIndexName } from '@core/type';
import { getPaletteHandlers } from '@core/util';

import { Icon } from '../icon';
import { IconProps } from '../icon/interface-icon';
import { Box } from '../layout';
import { InputHidden } from './InputHidden';
import { InputSwitchProps } from './interface-input';

const StyledSwitchLabel = styled.label<Pick<InputSwitchProps, 'isChecked'>>(
  ({ isChecked, theme: { palette } }) => {
    const { getBackgroundColor } = getPaletteHandlers(palette);

    return css`
      position: relative;
      cursor: pointer;
      display: inline-block;
      width: 62px;
      height: 28px;
      background-color: ${getBackgroundColor(isChecked ? EColor.ACCENT : EColor.NEUTRAL)};
      border-radius: 34px;
      transition: background-color 0.2s;

      &:before {
        content: '';
        position: absolute;
        left: 3px;
        bottom: 3px;
        width: 22px;
        height: 22px;
        z-index: 2;
        background-color: ${getBackgroundColor({
          commonType: EColor.WHITE,
          intensity: EColor.R900,
        })};
        border-radius: 50%;
        transition: transform 0.3s;
        transform: ${isChecked ? 'translateX(34px)' : 'none'};
      }
    `;
  },
);

const SwitchIcon = (props: IconProps) => (
  <Icon
    position={'absolute'}
    transition={'all 0.3s'}
    pointerEvents={'none'}
    zIndex={EZIndexName.OVER_DEFAULT}
    color={{ commonType: EColor.WHITE, intensity: EColor.R900 }}
    {...props}
  />
);

export const InputSwitch = ({ isChecked, ...restProps }: InputSwitchProps) => {
  return (
    <Box position={'relative'} width={'62px'} height={'28px'}>
      <SwitchIcon
        type={EIcon.CROSS}
        top={'calc(50% - 8px)'}
        right={'12px'}
        opacity={isChecked ? '0' : '0.5'}
      />
      <SwitchIcon
        type={EIcon.CHECK}
        top={'calc(50% - 16px)'}
        left={'0'}
        opacity={isChecked ? '0.5' : '0'}
        strokeWidth={0.6}
        size={ESize.LG}
      />
      <StyledSwitchLabel isChecked={isChecked}>
        <InputHidden type={'checkbox'} checked={isChecked} {...restProps} />
      </StyledSwitchLabel>
    </Box>
  );
};
